/**
 * queryTracker.js — Réponses de liste arrivées dans le désordre.
 *
 * Table lance une requête à chaque frappe. La recherche d'une seule lettre
 * ("a") renvoie des milliers de lignes et répond après celle du mot complet
 * ("abdmouleh") : sa réponse, arrivée en dernier, remplaçait les bons résultats.
 *
 * Chaque page affiche elle-même ses lignes (setData) : Table ne peut pas bloquer
 * une réponse périmée, seulement la reconnaître et recharger la requête en cours.
 */
export default function createQueryTracker() {
  let current = null;
  let currentLoaded = false;

  return {
    // À appeler quand une requête part ; `query` identifie ses paramètres.
    begin(query) {
      if (query !== current) {
        current = query;
        currentLoaded = false;
      }
      let reloadAsked = false;

      return {
        // La réponse correspond-elle à ce que l'écran demande maintenant ?
        isCurrent() {
          if (query !== current) return false;
          currentLoaded = true;
          return true;
        },
        // Vrai une seule fois, pour une réponse périmée arrivée APRÈS les bons
        // résultats. Si ceux-ci sont encore en route, ils la remplaceront.
        needsReload() {
          if (query === current || !currentLoaded || reloadAsked) return false;
          reloadAsked = true;
          return true;
        },
      };
    },
  };
}
